<template>
    <div class="nft-card-info-comp">
        <div class="nft-card-info-header" v-if="isHeader">
            <div class="header-title">
                <img src="@/assets/images/icons/nft-info.svg" alt="">
                <div>{{ $t("nftCard.precautionTitle") }}</div>
            </div>
            <div class="header-close">
                <img src="@/assets/images/icons/close_24.svg" @click="closeSlide">
            </div>
        </div>
        <MvPageTab
            v-if="isQtnr"
            v-model:selected="selectedInfo"
            :tabs="[
                {
                  name: 'nftCard.precaution.tabs.nft',
                  value: 'nft',
                },
                {
                  name: 'nftCard.precaution.tabs.attendee',
                  value: 'attendee',
                },
            ]"
            class="mb-16"
        />
        <div v-show="!isQtnr || selectedInfo === 'nft'" class="nft-card-info-item-list">
          <div class="nft-card-info-item-section">
            <div class="nft-card-info-item mb-16" v-if="data.sellYn !== undefined">
              <div class="nft-card-info-title mb-8">
                {{ $t("nftCard.precaution.reSale.title") }}
              </div>
              <div class="nft-card-info-content">
                <div  v-if="data.sellYn">
                  <div class="info-row mb-4">
                    <div class="info-col">
                      {{ $t('payDetail.maxPrice') }}
                    </div>
                    <div class="nft-card-info-content" v-if="data.maxPrice">
                      {{ $t(currency.i18nUnit, [data.maxPrice.toLocaleString()]) }}
                    </div>
                    <div class="nft-card-info-content" v-else>
                      -
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="info-col">
                      {{ $t('payDetail.royalties') }}
                    </div>
                    <div class="nft-card-info-content">
                      {{ data.royalty }}%
                    </div>
                  </div>
                </div>
                <div class="info-col" v-else>
                  {{ $t("nftCard.precaution.unAvail") }}
                </div>
              </div>
            </div>
            <div class="nft-card-info-item" v-if="data.transferYn !== undefined">
              <div class="nft-card-info-title mb-8">
                {{ $t("nftCard.precaution.transfer.title") }}
              </div>
              <div class="info-col">
                {{ data.transferYn ? $t("nftCard.precaution.avail") : $t("nftCard.precaution.unAvail") }}
              </div>
            </div>
          </div>
          <div class="nft-card-info-item-section">
              <div class="nft-card-info-item">
                  <div class="nft-card-info-title mb-12">
                      {{ $t("nftCard.precaution.description.title") }}
                  </div>
                  <div class="nft-card-info-content">
                      <div>
                          {{ data.description ? data.description : $t("nftCard.precaution.description.empty") }}
                      </div>
                  </div>
              </div>
          </div>
          <div class="nft-card-info-item-section">
              <div class="nft-card-info-item">
                  <div class="nft-card-info-title mb-12">
                      {{ $t("nftCard.precaution.considerations.title") }}
                  </div>
                  <div class="nft-card-info-content">
                    <div>
                        {{ data.memo ? data.memo : $t("nftCard.precaution.considerations.empty") }}
                    </div>
                  </div>
              </div>
          </div>
        </div>
        <div v-show="selectedInfo === 'attendee'" class="nft-card-info-item-list">
          <NftCardQtnrInfoComp :qtnr-info="data.qtnrInfo" :qtnr-template="data.qtnrTemplate" />
        </div>
    </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from "vue";
import {CURRENCY_TYPE, CurrencyType} from '@/models/types';
import MvPageTab from '@/components/common/tab/MvPageTab.vue';
import NftCardQtnrInfoComp from '@/components/common/modal/comp/NftCardQtnrInfoComp.vue';

export default defineComponent({
  name: "NftCardInfoComp",
  emit: ["cancel", "close"],
  components: {
    MvPageTab,
    NftCardQtnrInfoComp,
  },
  props: {
      title: {
          default: "",
      },
      data: {
          default: {
            priceUnit: '',
            cltnId: 0,
            qtnrInfo: {},
            qtnrTemplate: []
          },
      },
      isHeader: {
        default: true,
      }
  },
  setup(props, context) {
    const closeSlide = () => {
        context.emit("cancel");
    };
    const currency = computed(() => {
      return CURRENCY_TYPE[props.data.priceUnit as CurrencyType]
    })
    const selectedInfo = ref('nft')
    const isQtnr = computed(() => {
      return props.data?.qtnrTemplate?.length
    })
    return {
      closeSlide,
      currency,
      selectedInfo,
      isQtnr,
    };
  },
});
</script>

